﻿$.fn.dxCtrlContentFormulaireReponse = function custom_dxCtrlContentFormulaireReponse(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentformulairereponse dx-ctrl");
        this.createInstance(new cdxCtrlContentFormulaireReponse(this, option));
    }
    return this;
}

window.cdxCtrlContentFormulaireReponse = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContentInner = null;
    var jauge = null;
    function mConstruit() {
        container.empty();
        //container.css("position", "relative")
        //container.css("border-top", theme.border)

        if (option.dataFormulaireReponse.vue == "0") {
            option.dataFormulaireReponse.vue = "1"
            option.bddCtrl.getObjet(option.dataFormulaireReponse).mSaveChamp("vue")
        }

        var $DivEntete = $("<div style='width:100%;padding:10px 15%;text-align:center;'/>").appendTo(container)
        //if (option.dataFormulaireReponse.id_table) {
        //    option.bddCtrl.mAjaxCall({
        //        command: "getlstdatavirtualgrid",
        //        data: [{ id_table: option.dataFormulaireReponse.id_table, id: option.dataFormulaireReponse.id }]
        //    }, function (data) {
        //        var dataTemplate = data.lstdatatemplate[0]
        //        var clDataSaisie = new cDataSaisie({ bddCtrl: option.bddCtrl })
        //        clDataSaisie.mInitWithDataTemplate(dataTemplate)
        //        var $Table = $("<table style='width:100%;'/>").appendTo($DivEntete)
        //        var $Tr = $("<tr/>").appendTo($Table)
        //        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        //        $("<div/>").appendTo($Td).dxCtrlDataSaisieVisu({
        //            bddCtrl: option.bddCtrl,
        //            dataSaisie: clDataSaisie.data
        //        })
        //        if (option.bddCtrl.objCptCli.objetMetier.hasBdd()) {
        //            var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        //            $("<div/>").appendTo($Td).dxCtrlButton({
        //                icon: "fas fa-arrow-up-right-from-square",
        //                hint: "Ouvrir la fiche du contact",
        //                onClick: function (e) {
        //                    e.event.stopPropagation()
        //                    option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataTemplate.id_table_key).nom, dataTemplate.id_key).mShowPopup()
        //                }
        //            })
        //        }
        //    })
        //} else {
        //    $("<div style='padding:15px;'/>").text("(Aucun contact lié à cette réponse)").appendTo($DivEntete)
        //}

        var $DivContent = $("<div style='width:100%;height:calc(100% - " + ($DivEntete.innerHeight()) + "px);' class='divcontent'/>").appendTo(container)
        $DivContentInner = $("<div style='width:100%;height:100%;'/>").appendTo($DivContent)
        resizeObserver.mAdd($DivEntete, function () { $DivContent.css("height", "calc(100% - " + (($DivEntete.is(":visible")) ? $DivEntete.innerHeight() : 0) + "px)") })

        mRempliReponse()

        mRempliBt()
    }

    var lstDoublon = []
    function mRempliReponse(funcFin) {
        ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo($DivContentInner).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            orientation: "horizontal",
            collapsibleLeft: false,
            collapsibleRight: false,
            withMarge: true,
            widthLeftInitial: container.innerWidth() / 2
        }).dxCtrlSplitterResize2("instance")

        ctrlResize.mConstruitLeft(function (contentElementLeft) {
            var dataJson = JSON.parse(option.dataFormulaireReponse.json)
            if (!dataJson.lst || dataJson.lst.length == 0) {
                contentElementLeft.css({
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center"
                })
                $("<div>Le répondant n’a saisi aucune donnée dans votre formulaire.</div>").appendTo(contentElementLeft)
            } else {
                var dxScroll = $("<div/>").appendTo(contentElementLeft).dxScrollView({}).dxScrollView("instance")
                $("<div style='font-size:130%;font-weight:bold;padding:5px;'>Liste des valeurs saisies</div>").appendTo(dxScroll.content())
                var $DivLstValue = $("<div style='padding-left:20px;'/>").appendTo(dxScroll.content())
                dataJson.lst = dataJson.lst.sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) })
                var lstEmail = []
                var lstTel = []
                var lstSite = []
                var lstNomStr = []
                dataJson.lst.forEach(function (itemData) {
                    var lstValue = []
                    switch (itemData.typeDevexpress) {
                        case "dxDateBox":
                        case "dxTextBox":
                        case "dxCtrlEmail":
                            if (itemData.value && itemData.value.length > 0) {
                                lstValue.push({
                                    html: itemData.value,
                                    text: itemData.value
                                })
                                valueHtml = itemData.value
                                if (itemData.typeDevexpress == "dxCtrlEmail") lstEmail.push({ email: itemData.value })
                                if (itemData.typChamp == "site_web") lstSite.push({ web: itemData.value })
                                if (itemData.typChamp == "nom_str") lstNomStr.push({ nom: itemData.value })
                            }
                            break;
                        case "dxTextArea":
                            if (itemData.value && itemData.value.length > 0) {
                                lstValue.push({
                                    html: itemData.value.replace(/\n/g, '<br>'),
                                    text: itemData.value
                                })
                            }
                            break;
                        case "dxNumberBox":
                            if (typeof itemData.value != 'undefined' && itemData.value != null) {
                                lstValue.push({
                                    html: itemData.value,
                                    text: itemData.value
                                })
                            }
                            break;
                        case "dxCtrlSaisieAdresse":
                            var cpVille = ""
                            if (itemData.value.cp && itemData.value.cp.length > 0) cpVille = itemData.value.cp
                            if (itemData.value.ville && itemData.value.ville.length > 0) cpVille += (cpVille.length > 0 ? " " : "") + itemData.value.ville
                            var dptRegion = ""
                            if (itemData.value.dpt && itemData.value.dpt.length > 0) dptRegion = itemData.value.dpt
                            if (itemData.value.region && itemData.value.region.length > 0) dptRegion += (dptRegion.length > 0 ? " " : "") + itemData.value.region

                            valueHtml = ""
                            if (itemData.value.ad1 && itemData.value.ad1.length > 0) valueHtml = itemData.value.ad1
                            if (cpVille.length > 0) valueHtml += (valueHtml.length > 0 ? "<br/>" : "") + cpVille
                            if (dptRegion.length > 0) valueHtml += (valueHtml.length > 0 ? "<br/>" : "") + dptRegion
                            if (itemData.value.pays && itemData.value.pays.length > 0) valueHtml += (valueHtml.length > 0 ? "<br/>" : "") + itemData.value.pays
                            lstValue.push({
                                html: valueHtml,
                                text: itemData.value
                            })
                            break;
                        case "dxButton":
                            break;
                        case "dxCheckBox":
                            if (typeof itemData.value != 'undefined' && itemData.value != null) {
                                valueHtml = (itemData.value ? "OUI" : "NON")
                                lstValue.push({
                                    html: valueHtml,
                                    text: valueHtml
                                })
                            }
                            break;
                        case "dxSelect":
                            if (itemData.value) {
                                itemData.value.forEach(function (o) {
                                    lstValue.push({
                                        html: o,
                                        text: o
                                    })
                                })
                            }
                            break;
                        case "dxCtrlTelephone":
                            if (typeof itemData.value != 'undefined' && itemData.value != null && itemData.value.tel_complet.length > 0) {
                                lstValue.push({
                                    html: itemData.value.tel_sms,
                                    text: itemData.value.tel_sms
                                })
                                lstTel.push({ tel_sms: itemData.value.tel_sms })
                            }
                            break;
                    }
                    if (lstValue.length > 0) {
                        $("<div style='font-weight:bold;padding:15px 0 5px 5px;'/>").appendTo($DivLstValue).text(itemData.titre)
                        lstValue.forEach(function (val) {
                            var $DivValue = $("<div style='font-style:italic;padding-left:40px;'/>").appendTo($DivLstValue)
                            var $i = $("<i class='fas fa-copy state-hover' style='padding:5px;'></i>").appendTo($DivValue)
                            $i.on("click", function (e) {
                                e.stopPropagation()
                                var $temp = $("<input>");
                                $("body").append($temp);
                                $temp.val(val.text).select();
                                document.execCommand("copy");
                                $temp.remove();
                                mNotify("L'adresse du dossier a été copiée dans le presse-papier", "success", 6000)
                            })
                            $("<span> </span>").appendTo($DivValue)
                            $("<span/>").appendTo($DivValue).html(val.html)
                        })

                    }
                })
                //$("<div/>").appendTo(dxScroll.content()).text(JSON.stringify(dataJson))
                //data.Json.lst
                if (!option.dataFormulaireReponse.id_table &&
                    (lstEmail.length > 0 || lstTel.length > 0 || lstSite.length > 0 || lstNomStr.length > 0)) {
                    option.bddCtrl.mAjaxCall({
                        command: "getdoublonformulaire",
                        lst_email: lstEmail,
                        lst_tel: lstTel,
                        lst_site: lstSite,
                        lst_nom_str: lstNomStr
                    }, function (data) {
                        lstDoublon = (data.lstdata ? data.lstdata : [])
                        mRempliRight()
                    })
                } else { mRempliRight() }
            }
        })

        function mRempliRight() {
            ctrlResize.mConstruitRight(function (contentElementRight) {
                if (option.dataFormulaireReponse.id_table) {
                    mRempliAvecFiche(contentElementRight)
                } else {
                    mRempliSansFiche(contentElementRight)
                }
            })
        }

    }

    function mRempliSansFiche(contentElement) {
        contentElement.empty()
        contentElement.css("padding", "10px")
        var $DivTotal = $("<div/>").appendTo(contentElement)
        //liste des fiches à créer
        var $DivFicheCree = $("<div/>").appendTo($DivTotal)
        var $Table = $("<table style='width:100%;padding-bottom:15px;'/>").appendTo($DivFicheCree)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:50%;padding-right:5px;'/>").appendTo($Tr)
        var dxBt = $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Structure",
            icon: "fas fa-certificate",
            hint: "Nouvelle structure",
            width: "100%",
            onClick: function (e) {
                jaugeDemarrage.mShow()
                var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("structures").mGetNewData())
                obj.mSave(function () {
                    option.dataFormulaireReponse.id_table = obj.mGetTable().id_table
                    option.dataFormulaireReponse.id = obj.data.id_structures
                    option.bddCtrl.getObjet(option.dataFormulaireReponse).mSave(function () {
                        jaugeDemarrage.mHide()
                        mConstruit()
                    })
                })
            }
        }).dxCtrlButton("instance")
        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
        var dxBt = $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Contact",
            icon: "fas fa-certificate",
            hint: "Nouveau contact",
            width: "100%",
            onClick: function (e) {
                jaugeDemarrage.mShow()
                var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("contact").mGetNewData())
                obj.mSave(function () {
                    option.dataFormulaireReponse.id_table = obj.mGetTable().id_table
                    option.dataFormulaireReponse.id = obj.data.id_contact
                    option.bddCtrl.getObjet(option.dataFormulaireReponse).mSave(function () {
                        jaugeDemarrage.mHide()
                        mConstruit()
                    })
                })
            }
        }).dxCtrlButton("instance")
        //chercher une fiche
        var dxSelect = $("<div/>").appendTo($DivTotal).dxCtrlSelectStructuresContact({
            bddCtrl: option.bddCtrl,
            title: (option.title ? option.title : "Choisir ou créer un contact..."),
            hideNew: true,
            optionButton: {
                icon: 'fas fa-portrait',
                icon2: "fas fa-certificate",
                colorIcone2: theme.colorBtIcon2,
                opacityIcone2: "0.9",
                txtTooltip: "Ajouter un nouveau contact",
                onClick: function (e) {
                    var clDataSaisieNew = new cDataSaisie({ bddCtrl: option.bddCtrl })
                    var pop = $("<div/>").appendTo(container).dxCtrlPopupBase({
                        showMaximize: false,
                        height: "auto",
                        width: 650,
                        title: "Créer un contact",
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding-top", "0")
                            $("<div/>").appendTo(contentElement).dxCtrlDataSaisieModif({
                                bddCtrl: option.bddCtrl,
                                dataSaisie: clDataSaisieNew.data,
                                showEmail: true,
                                showSociete: true,
                                showTel: true
                            })
                            mAddButtonOkAnnuler(contentElement,
                                function () { //ok
                                    jauge.mShow()
                                    pop.hide();
                                    clDataSaisieNew.mSaveInDataTemplate(function (dataTemplate) {
                                        option.dataDocCptClient.idTable = dataTemplate.id_table
                                        option.dataDocCptClient.id = dataTemplate.id
                                        clDataSaisieNew.mSaveInDocCptClient(option.dataDocCptClient)
                                        if (option.onValueChanged) option.onValueChanged()
                                        mConstruit()
                                    })
                                },
                                function () { //annuler
                                    pop.hide();
                                }).table.css("margin-top", "20px")
                        }
                    }).dxCtrlPopupBase("instance")
                    pop.show()
                }
            },
            optionSearch: {
                withTextStr: true,
                withTextCon: true,
                title: option.title,
                //textStartWithText: "Créer un nouveau contact avec le nom/prénom ",
                withBdd: true,
                withinsee: true,
                withGoogleMaps: true,
                lstIdTable: option.bddCtrl.table.mGetItemFromNom("structures").id_table + "," + option.bddCtrl.table.mGetItemFromNom("structures_contact").id_table + "," + option.bddCtrl.table.mGetItemFromNom("contact").id_table,
                type: "all",
                onClickElement: function (lstItemData) {
                    mSelectNewClient(lstItemData[0].id_table, lstItemData[0].id)
                },
                onClickEtablissementInsee: function (itemData) {
                    jaugeDemarrage.mShow()
                    option.bddCtrl.mAjaxCall({ command: "createstructurefromdatainsee", data: itemData }, function (data) {
                        option.bddCtrl.triggerFunctionOnModifiedItemData("structures", "new", option.bddCtrl.getObjet("structures", data.id_structures).data)
                        mSelectNewClient(option.bddCtrl.table.mGetItemFromNom("structures").id_table, data.id_structures)
                        jaugeDemarrage.mHide()
                    })
                },
                onClickItemDataGoogleMaps: function (itemData) {
                    jaugeDemarrage.mShow()
                    option.bddCtrl.mAjaxCall({ command: "createstructurefromdatagooglemaps", data: itemData }, function (data) {
                        option.bddCtrl.triggerFunctionOnModifiedItemData("structures", "new", option.bddCtrl.getObjet("structures", data.id_structures).data)
                        mSelectNewClient(option.bddCtrl.table.mGetItemFromNom("structures").id_table, data.id_structures)
                        jaugeDemarrage.mHide()
                    })
                },
                onClickText: function (itemDateText) {
                    switch (itemDateText.type) {
                        case "aa_con_text":
                            jauge.mShow()
                            var nomPrenom = new cNomPrenom(option.bddCtrl, itemDateText.text)
                            var dataToBeSent = { command: "createcontactfromnomprenom", id_titre: nomPrenom.id_titre, nom: nomPrenom.nom, prenom: nomPrenom.prenom }
                            option.bddCtrl.mAjaxCall(dataToBeSent, function (data) {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("contact", "new", option.bddCtrl.getObjet("contact", data.id_contact).data)
                                mSelectNewClient(option.bddCtrl.table.mGetItemFromNom("contact").id_table, data.id_contact)
                            })
                            break;
                        case "aa_str_text":
                            var dataToBeSent = { command: "createstructuresfromnom", nom_str: itemDateText.text }
                            option.bddCtrl.mAjaxCall(dataToBeSent, function (data) {
                                option.bddCtrl.triggerFunctionOnModifiedItemData("structures", "new", option.bddCtrl.getObjet("structures", data.id_structures).data)
                                mSelectNewClient(option.bddCtrl.table.mGetItemFromNom("structures").id_table, data.id_structures)
                            })
                            break;
                    }
                }
            }
        }).dxCtrlSelectStructuresContact("instance")
        dxSelect.element().attr("title", "Saisissez le nom/prénom d'un contact à rechercher dans votre base ou le nom/prénom d'un nouveau contact à créer...")
        window.setTimeout(function () { dxSelect.focus() }, 200)
        //liste des fiches trouvées
        if (lstDoublon.length > 0) {
            $("<div style='height:calc(100% - " + ($DivFicheCree.innerHeight() + dxSelect.element().innerHeight()) + "px)'/>").appendTo($DivTotal).dxCtrlGridStrCon({
                bddCtrl: option.bddCtrl,
                noDataText: "Aucune fiche",
                context_grid: "gridstrconformulaire",
                hideEntete: true,
                lstTypeGrille: ["Lignes"],
                paddingLeftRightRow: "5px",
                showBtNew: false,
                allowCarto: false,
                allowCheck: false,
                allowClick: false,
                showFilterRempli: false,
                lstIdTableIdInclu: lstDoublon
            })
        }
    }

    function mSelectNewClient(idTable, id) {
        option.dataFormulaireReponse.id_table = idTable
        option.dataFormulaireReponse.id = id
        option.bddCtrl.getObjet(option.dataFormulaireReponse).mSave(function () {
            mConstruit()
        })
    }

    function mRempliAvecFiche(contentElement) {
        contentElement.empty()
        contentElement.css("padding", "10px")
        var dxBt = $("<div style='padding-bottom:15px;'/>").appendTo(contentElement).dxCtrlButton({
            text: "Détacher la fiche",
            width: "100%",
            onClick: function (e) {
                option.dataFormulaireReponse.id_table = null
                option.dataFormulaireReponse.id = null
                option.bddCtrl.getObjet(option.dataFormulaireReponse).mSave(function () {
                    mConstruit()
                })
            }
        }).dxCtrlButton("instance")
        var dxScroll = $("<div style='height:calc(100% - " + dxBt.element().innerHeight() + "px)'/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
        $("<div/>").appendTo(dxScroll.content()).dxCtrlContentStrConSimple({
            bddCtrl: option.bddCtrl,
            idTable: option.dataFormulaireReponse.id_table,
            id: option.dataFormulaireReponse.id,
            dxScroll: dxScroll,
            paddingLeftStrPx: 0
        })
    }

    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fafa fafa-formulaire",
                    icon2: "fas fa-arrow-right",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Ouvrir le formulaire.",
                    onClick: function (e) {
                        option.bddCtrl.getObjet("formulaire", option.dataFormulaireReponse.id_formulaire).mShowPopup()
                    }
                });
            },
        })

        itemsToolbar.push(getToolbarSeparator())
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        option.bddCtrl.getObjet(option.dataFormulaireReponse).mDelData()
                        page.mRemovePopup(option.dataFormulaireReponse)
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)

    }

    this.element = function () { return container }

    mConstruit();
}